<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12lEc9P/images/e9781439636183_cover.jpg?1684255619975" alt="This image is the cover for the book Philadelphia Neighborhoods, Postcard History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Philadelphia Neighborhoods, Postcard History Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Philadelphia Neighborhoods is a compendium of historic views of the major residential sections of Philadelphia.</b></p><br/><p>This book presents a snapshot into the past when old neighborhoods were not so old and when currently established ones were as yet new construction. Through the medium of postcards, readers are invited back to an era before automobiles dominated the streets, before many city roads were paved, and when the local grocery store was not located in a mall. Using chapters divided into subsections that detail the various regions of North, South, Southwest, and West Philadelphia, as well as the "new" Northeast Philadelphia, the author chronicles the vibrant, diverse communities that have helped shape the city's rich history. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gus Spector
      </h2>
      
      <p class="authorDescription body article">Gus Spector, a native of Philadelphia, is a graduate of South Philadelphia High School and Temple University. Spector is a member of the Historical Society of Pennsylvania, the Atwater Kent Museum of Philadelphia, and the American Philatelic Society. He is the author of Philadelphia: Historic Exteriors and Interiors and Center City Philadelphia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b1f6f7e